<ng-container *ngIf="rtOverlayState$ | async as rtOverlay">
  <div
    *ngIf="rtOverlay.visible"
    class="rt-overlay"
    (click)="onBackdropClick($event)">
  <div
    class="rt-overlay__container"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="labels.title">
    <div class="rt-overlay__content bg-white">
      <lib-block-title
        class="rt-overlay__title"
        [title]="labels.title">
      </lib-block-title>

      <section class="rt-overlay__panel rt-overlay__panel--daily">
        <lib-daily-state-overview
          class="rt-overlay__block rt-overlay__block--daily"
          [labels]="labels.dailyState"
          [refresh$]="refresh$"
          [todayMode]="true"
          [rtZoomMode]="true"
          [showCalendarPicker]="false"
          [showPowerTitle]="false"
          [showEnergyOverview]="false"
          [system]="system">
        </lib-daily-state-overview>

        <div class="rt-overlay__mini-flow">
          <lib-flow-chart
            class="rt-overlay__block rt-overlay__block--flow-mini"
            [labels]="labels.flowChart"
            [showWeather]="false"
            [showLastUpdated]="false"
            [showIrradianceInfo]="false"
            [powerUnit]="'kW'"
            [refresh$]="refresh$"
            [system]="system">
          </lib-flow-chart>
        </div>
      </section>
    </div>

    <div class="rt-overlay__toolbar">
      <div class="rt-overlay__status">
        <span
          class="rt-overlay__badge"
          [class.rt-overlay__badge--active]="rtOverlay.isActive && !rtOverlay.isStopping"
          [class.rt-overlay__badge--ending]="rtOverlay.isStopping"
          [class.rt-overlay__badge--ended]="!rtOverlay.isActive && rtOverlay.hasJustEnded">
          {{ rtOverlay.isStopping ? labels.stopping : (rtOverlay.isActive ? labels.live : (rtOverlay.hasJustEnded ? labels.ended : labels.idle)) }}
        </span>
        <span class="rt-overlay__time" *ngIf="rtOverlay.isActive || rtOverlay.hasJustEnded">
          {{ rtOverlay.isActive ? (labels.endsIn + ' ' + formatCountdown(rtOverlay.countdownSeconds)) : (labels.endedAt + ' ' + rtOverlay.endedAtLabel) }}
        </span>
      </div>

      <div class="rt-overlay__actions">
        <button
          type="button"
          class="rt-overlay__action rt-overlay__action--hide"
          (click)="onClose()">
          <ion-icon name="eye-off-outline"></ion-icon>
          <span>{{ labels.hide }}</span>
        </button>
        <button
          *ngIf="rtOverlay.isActive"
          type="button"
          class="rt-overlay__action rt-overlay__action--stop"
          [disabled]="rtOverlay.isStopping"
          (click)="onStop()">
          <ion-icon name="stop-circle-outline"></ion-icon>
          <span>{{ labels.stop }}</span>
        </button>
        <button
          *ngIf="!rtOverlay.isActive"
          type="button"
          class="rt-overlay__action rt-overlay__action--start"
          [disabled]="!rtOverlay.canUseRealTime"
          (click)="onStart()">
          <ion-icon [name]="rtOverlay.hasJustEnded ? 'refresh-circle-outline' : 'play-circle-outline'"></ion-icon>
          <span>{{ rtOverlay.hasJustEnded ? labels.restart : labels.start }}</span>
        </button>
      </div>
    </div>

    <div class="rt-overlay__progress" *ngIf="rtOverlay.isActive || rtOverlay.hasJustEnded">
      <div class="rt-overlay__progress-track">
        <div class="rt-overlay__progress-value" [style.width.%]="rtOverlay.rtProgress"></div>
      </div>
    </div>
  </div>
  </div>
</ng-container>
